<div
  [ngClass]="{
    'upload-document bg-card py-5 xs:py-0 max-w-3xl m-auto': !isIncludedInsideMatForm,
  }">
  <div
    *ngIf="title !== '' && subtitle !== ''"
    class="max-w-xl text-center text-black m-auto pb-5">
    <h1 class="mb-5">{{ title | translate }}</h1>
    <p>{{ subtitle | translate }}</p>
  </div>
  <div *ngIf="!isProofOfPayment">
    <ew-upload-files
      *ngFor="let file of files; index as i"
      [buttonTextUpload]="buttonTextUpload"
      [acceptedTypes]="acceptedTypes"
      [file]="filesData[i]"
      [required]="required"
      [maxSize]="maxSize"
      [infoDialog]="infoDialog"
      (valueChanged)="handleValueChanged($event, i)"
      [label]="file.label"></ew-upload-files>
  </div>

  <div
    *ngIf="isProofOfPayment"
    class="text-cool-gray-800 grid grid-cols-1 divide-y border rounded-lg p-10 xs:p-3 scroll max-h-[calc(100%-220px)]">
    <ew-upload-proof-of-payment
      *ngFor="let file of files; index as i"
      [file]="filesData[i]"
      [expirationDate]="expirationDate"
      [required]="required"
      (valueChanged$)="filesData[i] = $event; send()"
      [label]="file.label"
      [status]="file.status"></ew-upload-proof-of-payment>
  </div>

  <div *ngIf="!isIncludedInsideMatForm" class="pb-5 flex justify-end pt-5">
    <button
      *ngIf="!loading && !isProofOfPayment"
      mat-stroked-button
      color="primary"
      class="text-md"
      (click)="send()">
      {{ 'shared:send' | translate }}
    </button>

    <div *ngIf="loading">
      <mat-progress-bar [color]="'primary'" [mode]="'indeterminate'">
      </mat-progress-bar>
    </div>
  </div>
</div>
